import { first } from "rxjs/operators";
import {
    Component,
    OnInit,
    OnDestroy,
    HostListener,
    Input,
} from "@angular/core";
import { SettingsService } from "../../services/settings/settings.service";
import { Store } from "@ngrx/store";
import { AppState } from "../../interfaces/app-state.interface";
import { AutoUnsubscribe } from "ngx-auto-unsubscribe";
import { EnvironmentAction } from "../../state-management/environment/environment.action";
import { UtilsAction } from "../../state-management/utils/utils.actions";
import { Subscription, Observable } from "rxjs";
import { Router } from "@angular/router";
import { EnvironmentState } from "../../state-management/environment/environment.reducer";
import { UserProfileActions } from "../../state-management/userprofile/userprofile.actions";
import { FinanceActions } from "../../state-management/finance/finance.action";
import { UserAccountLevel } from "../../enum/user/account-level";

const disclaimerEasterEggTriggerAmount = 3;
const easterEggKey = "T";

@AutoUnsubscribe()
@Component({
    selector: "hub-footer",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit, OnDestroy {
    public showPhoneSpecial: boolean = false;
    public contact: any;
    public version: string;
    public debugMode$: Observable<boolean>;
    public environment$: Observable<EnvironmentState>;
    public currentDomain: string;
    public defaultEnvironment: string;
    public commonPackageVersion: string;
    public debugModeSubscription: Subscription;
    public disclaimerEasterEggCount: number = 0;
    public envivonrmentSubscription: Subscription;

    @Input()
    public externalRouter: boolean = false;

    @Input()
    public logoPath: string = "/assets/images/toro-total-white.svg";

    constructor(
        private settingsService: SettingsService,
        private store: Store<AppState>,
        private router: Router
    ) {
        this.version = this.settingsService.getConfigurationKeyValue("version");
        this.debugMode$ = this.store.select(
            (state) => state.utils.debugModeEnabled
        );
        this.environment$ = this.store.select((state) => state.environment);
        this.defaultEnvironment = this.settingsService.baseUrl("");
        this.commonPackageVersion =
            this.settingsService.getConfigurationKeyValue(
                "commonPackageVersion"
            );
    }

    public ngOnInit() {
        this.store.dispatch({ type: UserProfileActions.getUser });
        this.store.dispatch({ type: FinanceActions.getFinancePosition });
        this.store.dispatch({ type: FinanceActions.getConsolidatePosition });
        this.store.dispatch({
            type: FinanceActions.getRealtimeFinancePosition,
        });
        this.store.dispatch({
            type: FinanceActions.getRealtimeConsolidatedPosition,
        });

        this.store
            .select(({ userProfile }) => userProfile.user)
            .combineLatest(
                this.store.select(({ finance }) => finance),
                this.store.select(
                    ({ authentication }) => authentication.currentUser
                )
            )
            .filter(
                ([{ profile }, { finance }, currentUser]) =>
                    !!profile && !!finance && !!currentUser
            )
            .subscribe(
                ([
                    user,
                    { finance, consolidatePosition: consolidated },
                    { cblc, cblcArray },
                ]) => {
                    this.showSupportPhone(consolidated.totalNetEquity);
                }
            );

        // Informaçãoes de contato
        this.contact =
            this.settingsService.getConfigurationKeyValue("contact") || {};

        // Informaçãoes técnicas de ambiente
        this.envivonrmentSubscription = this.store
            .select((state) => state.environment)
            .subscribe(
                (environment) =>
                    (this.currentDomain = environment.currentEnvironment)
            );

        // Debug
        this.debugModeSubscription = this.store
            .select((state) => state.utils.debugModeEnabled)
            .pipe(first((enabled) => enabled))
            .subscribe(() =>
                this.store.dispatch({
                    type: EnvironmentAction.getEnvironmentMachine,
                })
            );
    }

    public ngOnDestroy() {
        // Não remover, necessário para o autounsubscribe
    }

    /**
     * Shift TTT
     */
    @HostListener("document:keydown", ["$event"])
    public onKeyPress(event: KeyboardEvent) {
        if (event.shiftKey && event.key === easterEggKey)
            this.store.dispatch({ type: UtilsAction.enableDebugMode });
    }

    /**
     * Determina se o shift TTT pode ser exibido
     */
    public get showDisclaimerEasterEgg() {
        return (
            this.disclaimerEasterEggCount === disclaimerEasterEggTriggerAmount
        );
    }

    /**
     * Redirecionar cliente
     *
     * @param url
     */
    public redirect(url: string) {
        if (
            this.externalRouter ||
            url.equals("/bolsa/investir") ||
            url.equals("/fundos/investir") ||
            url.equals("/produtos-renda-fixa/investir") ||
            new RegExp("/home").test(window.location.href)
        ) {
            if (window.location.href !== url) window.location.href = url;

            return;
        }

        this.router.navigateByUrl(url);
    }

    /**
     * Cria o elemento com o número do telefone para atendimento de clientes Premium.
     * Está sendo injeto no DOM via javascript pois não podemos permitir que este número de telefone
     * seja indexado pelo Google e qualquer pessoa tenha acesso.
     * Apenas para usuários Premium.
     */
    // private createSupportPhoneDOM() : void {
    //     const hasFooterSupportPhoneAlreadyExists = !!(document.querySelector('#support-phone-number p'));

    //     if(hasFooterSupportPhoneAlreadyExists) return;

    //     const footerSupportPhoneWrapper = document.querySelector('#support-phone-number');
    //     const footerSupportPhoneElement = document.createElement('p');
    //     footerSupportPhoneElement.innerHTML = 'Telefone: <a href="tel:+551140001580" class="font-small--regular link font-light-color">4000-1580</a>';

    //     footerSupportPhoneWrapper
    //         .append(footerSupportPhoneElement);
    //     footerSupportPhoneWrapper.classList.remove('hidden');
    // }

    /**
     * Exibe o telefone de atendimento se o usuário logado pertencer
     * a categoria PREMIUM
     *
     * @param totalNetEquity valor total do patrimônio do usuário
     */
    private showSupportPhone(totalNetEquity: number): void {
        this.showPhoneSpecial = totalNetEquity >= UserAccountLevel.PREMIUM;
        // if (
        //     totalNetEquity >= UserAccountLevel.PREMIUM
        // ) this.createSupportPhoneDOM();
    }
}
